import { Observable } from 'rxjs';

import { Phase } from '../../../domain/phase/phase';

export abstract class PhaseRepositoryPort {
	public abstract observePhasesByOrganizationId(
		organizationId: string
	): Observable<Phase[]>;

	public abstract observePhaseById(id: string): Observable<Phase>;

	public abstract savePhases(phases: Phase[]): Promise<void>;
}
